import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=449b8aac"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports